import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { InstagramButton } from "./InstagramButton";
import { NAV } from "@/data/content";
import { scrollToId } from "./Reveal";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => (e) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow] duration-500 ${scrolled ? "bg-cream/85 backdrop-blur-xl shadow-[0_10px_30px_-20px_rgba(64,52,52,0.35)]" : "bg-blush/70 backdrop-blur-md"}`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Logo onClick={go("top")} />
        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <a key={n.id} href={`#${n.id}`} onClick={go(n.id)} data-testid={`nav-link-${n.id}`} className="nav-link text-sm text-ink/85 hover:text-ink">
              {n.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <InstagramButton label={false} className="hidden sm:flex" />
          <div className="hidden sm:block">
            <a href="#enquiry" onClick={go("enquiry")} data-testid="header-book-button" className="btn-pink">
              Book a consultation
            </a>
          </div>
          <InstagramButton label={false} className="sm:hidden" />
          <button data-testid="mobile-menu-toggle" aria-label="Menu" onClick={() => setOpen((o) => !o)} className="lg:hidden w-11 h-11 rounded-full bg-white/70 border border-terra/20 flex items-center justify-center text-ink">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden overflow-hidden bg-cream border-t border-terra/10"
          >
            <div className="px-6 py-6 flex flex-col gap-1">
              {NAV.map((n) => (
                <a key={n.id} href={`#${n.id}`} onClick={go(n.id)} data-testid={`mobile-nav-link-${n.id}`} className="font-display text-2xl py-2 text-ink">
                  {n.label}
                </a>
              ))}
              <a href="#enquiry" onClick={go("enquiry")} data-testid="mobile-book-button" className="btn-pink mt-4 justify-center">Book a consultation</a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
